// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import VueSession from 'vue-session'
import VueMask from 'v-mask'
import 'bootstrap/dist/css/bootstrap.css'
import vueXlsxTable from 'vue-xlsx-table'
// import axios from 'axios'
// import moment from 'moment' // แปลง date
import Nl2br from 'vue-nl2br'
import store from './store'
// import Swal from 'sweetalert2'
import Embed from 'v-video-embed'
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import VueOtp2 from 'vue-otp-2'
// import io from 'socket.io-client'
// import VueSocketio from 'vue-socket.io-extended'

// import VueQrcodeReader from 'vue-qrcode-reader'
// import { mapActions, mapGetters } from 'vuex'
import globalMixin from '@/mixins/globalMixin'

Vue.prototype.$firebase = window.firebase
Vue.config.productionTip = false
Vue.component('nl2br', Nl2br)
Vue.use(VueSession)
Vue.use(VueMeta)
Vue.use(VueMask)
Vue.use(Embed)
Vue.use(VueOtp2)
Vue.use(VueI18n)
Vue.use(vueXlsxTable, { rABS: false })
// Vue.use(VueSocketio, io('http://localhost:5001'))
// Vue.use(VueQrcodeReader)

Vue.prototype.$profile_dev = {
  'userId': 'U92e8d994e0a5fb008e6ed2087deed044',
  // 'userId': 'U4e20c0e9caa5b6859faa29ee2e1165cd',
  'displayName': 'FRooKFERNOE',
  'statusMessage': 'FN(:{)l\uD83C\uDFC0',
  'pictureUrl': 'https://profile.line-scdn.net/0hjIKuhYR4NWZmDCRQ0oZLGRZcNgxFfWx0S2NyCFYFPFJca3RkHjkpU1pbOF8INSI5SGlyAFZePl9qH0IAeFrJUmE8aFdaPnQ1QmJ7gg'

}
// {
//   'displayName': 'Flxk',
//   'pictureUrl': 'https://profile.line-scdn.net/0hjIKuhYR4NWZmDCRQ0oZLGRZcNgxFfWx0S2NyCFYFPFJca3RkHjkpU1pbOF8INSI5SGlyAFZePl9qH0IAeFrJUmE8aFdaPnQ1QmJ7gg',
//   'statusMessage': 'บังไค (Smug)',
//   // 'userId': 'Uc8835956a8885d5b626811233a7b6abb'
//   // 'userId': 'U5950278d35144c0c886b11411b82efc7'
//   // 'userId': 'U71dbfa8feed0c9b114e2521465e2b302'
//   // 'userId': 'Udb1efb81fb073672c77395b64c3f7732'
//   // 'userId': 'U0f2c090ee3ece45745b82640b7fa047dp'
//   // 'userId': 'U1f6a9db8c0c69682b695dc4d24b2deb5'
//   // 'userId': 'U417326b09b92594c8f9408885ce747ec'
//   // 'userId': 'U94653898da05b11e6c4c5970d870baac'
// }
// Vue.prototype.$profile_dev = {
//   'displayName': 'Pamorn Trivorrarat',
//   'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
//   'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
//   'userId': 'U691b2080970333bbeb4930dadc6618b6'
// }

Vue.prototype.$weburl = 'https://betask-loyalty-web.web.app'
// Vue.prototype.$liffId = '1653760842-MrXDg0Vx'
Vue.prototype.$liffId = null
Vue.prototype.$checkGetReward = false
Vue.prototype.$liff = window.liff
Vue.prototype.$store = store
Vue.prototype.$master_theme = this.master_theme
Vue.prototype.$showHome = false
Vue.prototype.$loadReward = false
Vue.prototype.$shopNameData = {
  // chubb: 'SD_1770104911502' // chubb development
  chubb: 'U53696ebf2bc8effeb59061ce66ade036' // chubb production
}
Vue.prototype.$isTargetShop = function () {
  const shopId = store.getters['shopStore/GET_SHOPID']
  const chubbId = this.$shopNameData && this.$shopNameData.chubb
  if (!shopId || !chubbId) return false
  return shopId === chubbId
}
// ร้านโหมดอีเวนต์: ตอบคำถามต่อกันจนครบ, กดรับของรางวัลโดยไม่ต้องโชว์โค้ดให้สตาฟ
// เพิ่ม shopId ของอีเวนต์ใหม่ (และร้านทดสอบ) ที่นี่ที่เดียว
// ตัวเลือกต่อร้านเปิดเฉพาะร้านที่ระบุ ร้าน CGS ไม่มีตัวเลือก = ทำงานแบบเดิมทุกอย่าง
//   skipOtp: ลงทะเบียนไม่ยืนยัน OTP · activitiesInOrder: การ์ดเรียงข้อ 1 ขึ้นก่อน
//   showEarnedCoin: แจ้งคะแนนตามจริงหลังตอบ (เดิมขึ้น "10 คะแนน")
//   stepActivities: หน้า /activity แบบสเตป ตอบข้อก่อนหน้าก่อนถึงจะเปิดข้อต่อไป (Activity/EventSteps.vue)
//   registerCover: พื้นหลังหัวหน้าสมัคร (ค่า CSS background) ใช้คู่กับ sheetRegisterForm
//   requireFriend: basic ID ของ OA ร้าน ต้องเพิ่มเพื่อนก่อนสมัคร (ใช้ได้เมื่อร้านมี LIFF ของตัวเองใน provider เดียวกับ OA)
const CBM_COVER = 'linear-gradient(180deg, #8b5cf6 0%, #c13fc0 55%, #ec2f86 100%)'
Vue.prototype.$eventShops = {
  'Ud9356d1cf189a31ab46cc5f424e14904': {}, // CGS CI&OE Day
  'U61df7c3ecd83109d811e2f4c8a1e4a7a': { skipOtp: true, activitiesInOrder: true, showEarnedCoin: true, sheetRegisterForm: true, stepActivities: true, registerCover: CBM_COVER, requireFriend: '@071jienu' } // CBM Event DEV (ทดสอบ)
}
Vue.prototype.$isEventShop = function (shopId) {
  return !!shopId && Object.prototype.hasOwnProperty.call(this.$eventShops, shopId)
}
Vue.prototype.$eventShopOption = function (shopId, key) {
  return this.$isEventShop(shopId) && !!this.$eventShops[shopId][key]
}
Vue.prototype.$eventShopValue = function (shopId, key) {
  return this.$isEventShop(shopId) ? this.$eventShops[shopId][key] : undefined
}

Vue.config.productionTip = false

// Set neutral default theme colors (overridden when theme loads in App.vue)
Vue.prototype.$bgColor = 'rgb(224, 224, 224)'
Vue.prototype.$bgColor2 = 'rgb(244, 244, 244)'
Vue.prototype.$bgColor3 = 'rgba(224, 224, 224, 0.3)'
Vue.prototype.$bgColorActivityCard = 'rgba(224, 224, 224, 0.7)'

Vue.prototype.$CUSTOMMainTextColor = '#000000FF'

Vue.prototype.$images = {
  Chubb: 'https://storage.googleapis.com/betask.appspot.com/BeConnect/DefaultImage/Chubb%20Logo-White%201.png',
  ChubbIconReward: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/copper-diamond-line.png',
  ChubbGift: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/grif.png',
  mapChubb: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/map-pin-2-line.png',
  phoneChubb: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/phone-line.png',
  timeChubb: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/time-line.png',
  dimondChubb: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/Vector.png',
  // imgCover2: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT6777_20250319025210589106.png',
  imgCover2: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT985_20250614163556699259.png',
  myReward: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT2730_20250612174402392174.png',
  myRewardWhite: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT5205_20250612174921725379.png',
  pointHistory: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT7498_20250306143853391733.png',
  pointHistoryWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/his.png',
  policy: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT4347_20250306143733724743.png',
  policyWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/policy.png',
  point: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/copper-diamond-line.png',
  pointWhite: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3632_20250311125630781929.png',
  credit: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT2323_20250306112832858882.png',
  creditWhite: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT2323_20250306112832858882.png',
  allLevel: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT8758_20250311140222905103.png',
  allLevelWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%A3%E0%B8%AA%E0%B8%A1%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%81%201.png',
  rewardHistory: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT8842_20250612180153433296.png',
  rewardHistoryWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%81%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B8%B2%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%A5%202.png',
  mapWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/contractY.png',
  mapBlack: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B9%88%E0%B8%AD%201.png',
  accountWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/profileY.png',
  accountBlack: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/profile.png',
  activityWhite: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/activityY.png',
  activityBlack: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/activity.png',
  promotionWhite: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT5342_20250313094311815247.png',
  promotionBlack: 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT8014_20250313093954628534.png',
  homeActive: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/homeACT.png',
  home: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/home.png',
  level: 'https://storage.googleapis.com/betask.appspot.com/BeLoyalty/vip-diamond-line.png'
}

const messages = {
  th: {
    message: {
      thisTelNotUsed: 'ไม่สามารถใช้เบอร์โทรศัพท์นี้ได้',
      confirm: 'ยืนยัน',
      yes: 'ใช่',
      nameOffice: '(ชื่อบริษัท)',
      hello: '👋 ยินดีต้อนรับ',
      welcomeToShop: 'ยินดีต้อนรับสู่ร้านค้าของเรา',
      detailMember: 'รายละเอียดสมาชิก',
      currntPoint: 'คะแนนปัจจุบัน',
      myReward: 'รางวัลของฉัน',
      MyReward: 'รางวัลของฉัน',
      privileges: 'แพ็กเกจ',
      memberId: 'รหัสสมาชิก',
      level: 'ระดับสมาชิก',
      nameSurname: 'ชื่อ-นามสกุล',
      nameSurnameEazyCar: 'ชื่อที่ระบุในสัญญา',
      nameSurnameStampCGS: 'ชื่อ-นามสกุล (ภาษาไทย)',
      tel: 'เบอร์โทรศัพท์',
      telCGS: 'เบอร์มือถือ',
      birtDay: 'วันเกิด',
      yougetPoint: 'คุณได้รับคะแนน',
      youUsePoint: 'คุณใช้',
      youRefund: 'เรียกคืน',
      point: 'คะแนน',
      thb: 'บาท',
      NotiUsePoint: 'รายการใช้คะแนน',
      new: 'ใหม่',
      before: 'ก่อนหน้านี้',
      language: 'TH',
      NotiGetPoint: 'รายการรับคะแนน',
      mypoint: 'คะแนนปัจจุบัน',
      promotion: 'โปรโมชั่น',
      campaign: 'แคมเปญ',
      allCampaign: 'แคมเปญทั้งหมด',
      validUntil: 'ใช้ก่อนวันที่',
      reward: 'ของรางวัล',
      viewAll: 'ดูทั้งหมด',
      notHavepromotion: 'ติดตามโปรโมชั่นน่าสนใจได้ที่นี่',
      buyPackage: 'ซื้อแพ็กเกจ',
      freePackage: 'รับแพ็กเกจฟรี',
      home: 'หน้าหลัก',
      account: 'บัญชี',
      activity: 'กิจกรรม',
      feedBack: 'แบบสอบถาม',
      fromFrigetFri: 'จากกิจกรรมเพื่อนชวนเพื่อน',
      fromWelcome: 'จากกิจกรรม Welcome point',
      fromActivity: 'จากกิจกรรม',
      fromBirth: 'จากกิจกรรม Birth day point',
      backToPromotion: 'กลับไปหน้าโปรโมชั่น',
      back: 'กลับ',
      succesRegis: 'ลงทะเบียนสำเร็จ',
      contact: 'ข้อมูลติดต่อ',
      seeMore: 'ดูรายละเอียด',
      allPromotion: 'โปรโมชั่นทั้งหมด',
      viewDetails: 'เข้าชมรายละเอียด',
      ReceiveAtStore: 'รับที่สำนักงานหรือหน้าร้าน',
      delivery: 'จัดส่ง',
      allReward: 'ของรางวัลทั้งหมด',
      outStock: 'สินค้าหมด',
      inventories: 'รายการสินค้า',
      visiter: 'จำนวนเข้าชม',
      redeemReward: 'แลกของรางวัล',
      showQrcodeReward: 'โปรดแสดง QR Code นี้ต่อพนักงาน',
      showBarcodeReward: 'โปรดแสดง Barcode นี้ต่อพนักงาน',
      rewardDetail: 'รายละเอียดของรางวัล',
      useBefor: 'ใช้ก่อนวันที่',
      collectMore: 'สะสมเพิ่ม',
      memberHightLevel: 'ระดับบัตรสมาชิกของคุณอยู่ระดับสูงสุดแล้ว',
      levelUp: 'เพื่อขึ้นเป็นระดับ',
      privilegeDetail: 'รายละเอียดสิทธิประโยชน์',
      expirePoint: 'คะแนนที่จะหมดอายุปี',
      expirePointTopic: 'คะแนนหมดอายุ',
      view: 'รายละเอียด',
      fromBuyAndService: 'จากการซื้อสินค้า',
      fromPackage: 'จากการซื้อแพ็กเกจ',
      fromRefund: 'จากการยกเลิกใบเสร็จ',
      allLevel: 'ระดับบัตรสมาชิกทั้งหมด',
      allLevels: 'ทุกระดับ',
      pointHistory: 'ประวัติการใช้คะแนน',
      policy: 'นโยบายความเป็นส่วนตัว',
      rewardHistory: 'ประวัติแลกของรางวัล',
      mounth: 'รายเดือน',
      youPoint: 'คะแนนของคุณ',
      useReward: 'ใช้ของรางวัล',
      received: 'ได้รับแล้ว',
      type: 'ประเภท',
      deliveryLocation: 'สถานที่จัดส่ง',
      transportationService: 'บริการขนส่ง',
      parcelNumber: 'เลขพัสดุ',
      linkcode: 'โค้ดหรือลิงก์ของรางวัล',
      waitDelivery: 'รอจัดส่ง',
      alreadyShip: 'จัดส่งแล้ว',
      redeemDate: 'แลกวันที่',
      myPackage: 'แพ็กเกจของฉัน',
      allPackage: 'แพ็กเกจทั้งหมด',
      presslink: 'กดลิงก์ด้านบนเพื่อรับของรางวัล',
      availablePackages: 'แพ็กเกจที่ใช้ได้',
      packageHistory: 'ประวัติการใช้แพ็กเกจ',
      unusablePackage: 'ใช้ไม่ได้แล้ว',
      dontUnusablePackage: 'คุณไม่มีแพ็กเกจที่หมดอายุหรือใช้หมดแล้ว',
      dontPackage: 'คุณไม่มีแพคเกจ',
      balance: 'ทั้งหมด',
      usePackeage: 'ใช้แพ็กเกจ',
      outPackage: 'หมดแล้ว',
      waitStore: 'โปรดรอทางร้านดำเนินการ',
      storeNotice: 'เมื่อทางร้านยืนยันสลิปโอนเงินจะมีข้อความแจ้งไปยังลูกค้าผ่านทาง Line oa ของร้าน',
      useAndappoint: 'แพ็กเกจและนัดหมาย',
      detailPackage: 'รายละเอียดแพ็กเกจ',
      productsServices: 'สินค้า/บริการ',
      productsServicesLMG: 'ยอดขาย',
      expirePoint2: 'คะแนนที่หมดอายุ',
      usePoint: 'ประวัติใช้คะแนน',
      date: 'วันที่',
      branch: 'สาขา',
      condition: 'ยอมรับเงื่อนไข',
      condition2: 'ยินยอมรับข่าวสารและสิทธิประโยชน์ ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมล จากบริษัท',
      selectGender: 'กรุณาเลือกเพศ',
      regisMember: 'สมัครสมาชิก',
      regisMemberConfirm: 'ยืนยันสมัครสมาชิก',
      register: 'ลงทะเบียน',
      registerRxTrader: 'ลงทะเบียนร่วมกิจกรรม',
      referralCode: 'รหัสแนะนำ',
      joinActivity: 'เข้าร่วมกิจกรรม',
      claimFree: 'กดรับฟรี',
      NoLimitPrivileges: 'ไม่จำกัดจำนวนสิทธิ์',
      getPoint: 'รับคะแนน',
      fullPrivilege: 'สิทธิ์เต็ม',
      friendFetFriend: 'เพื่อนแนะนำเพื่อน',
      getFriendHistory: 'ประวัติชวนเพื่อน',
      inviteUseservice: 'ชวนเพื่อนเข้าใช้บริการ',
      pointsEarned: 'คะแนนที่ได้',
      referralQuota: 'คุณได้ชวนเพื่อนครบโควต้าแล้ว',
      startActivity: 'เริ่มกิจกรรม',
      Invitemembership: 'ชวนเพื่อนเปิดบัตรสมาชิก',
      canInvite: 'ชวนเพื่อนได้',
      InviteServiceReceive: 'ชวนเพื่อนเข้าใช้บริการรับ',
      howtoGetFriend: 'วิธีชวนเพื่อน',
      shareLinkLine: 'แชร์ลิงก์ไปยังใน Line application (กดที่ icon line)',
      EarnInvitingFriends: 'รับคะแนนชวนเพื่อน',
      wayGetFriend: 'สามารถเลือกชวนเพื่อนได้',
      towWay: '2 วิธี',
      Method1: 'วิธีที่ 1',
      Method2: 'วิธีที่ 2',
      NoLimit: 'ไม่จำกัดจำนวน',
      countTime: 'คน',
      shareCode: 'แชร์โค้ดด้านล่างกับเพื่อน',
      copy: 'คัดลอก',
      allPointGet: 'คะแนนที่ได้ทั้งหมด',
      address: 'ที่อยู่',
      allBranch: 'สาขาทั้งหมดของเรา',
      map: 'แผนที่',
      credit: 'เครดิต',
      historyCredits: 'ประวัติเครดิต',
      myCredis: 'เครดิตของฉัน',
      currentCredits: 'เครดิตปัจจุบัน',
      totalCredits: 'เครดิตสะสม',
      status: 'สถานะ',
      increase: 'เพิ่ม',
      decrease: 'ลด',
      rewardCode: 'รหัสของรางวัล',
      completeReward: 'แลกของรางวัลเรียบร้อย',
      expireDate: 'วันหมดอายุ',
      collectedReward: 'ของรางวัลนี้ต้องไปรับที่สำนักงานเท่านั้น.',
      collectedStaffReward: 'ของรางวัลนี้ต้องไปรับที่ staff ภายในงานเท่านั้น.',
      Viewrewards: 'ดูของรางวัลของคุณทั้งหมด',
      ConfirmReward: 'ยืนยันแลกของรางวัล',
      create: 'สร้าง',
      cancle: 'ยกเลิก',
      use: 'ใช้',
      useLinkOrCode: 'สามารถนำ code หรือ link ด้านบนไปใช้เพื่อรับสิทธิพิเศษในโปรแกรมได้เลย',
      pointInsufficient: 'คะแนน ของคุณไม่พอ',
      howToGetPoint: 'คุณต้องการไป ดูเงื่อนไขรับคะแนนหรือไม่ ?',
      memberInsufficient: 'ระดับบัตรสมาชิกไม่พอ :(',
      redeemLevel: 'สามารถเเลกได้เฉพาะ member ที่มีเลเวล',
      orHight: 'ขึ้นไปเท่านั้น',
      uploadPayment: 'อัปโหลด สลิปโอนเงิน.',
      save: 'บันทึก',
      accountBank: 'บัญชี',
      amount: 'จำนวนเงิน',
      afterUpload: 'หลังจากโอนเงินสำเร็จกรุณาอัพสลิปโอนเงิน',
      selectPayment: 'เลือกช่องทางการชำระเงิน',
      paymentTotal: 'ยอดชำระ',
      sorry: 'ขออภัย',
      alreadyUsePackage: 'แพ็กเกจนี้ถูกใช่ไปแล้ว',
      wantToupLoadPayment: 'ต้องการยืนยันอัปโหลดสลิปโอนเงินใช่หรือไม่',
      complete: 'สำเร็จ',
      fail: 'ผิดพลาด',
      ok: 'รับทราบ',
      message: 'ตั๋วกดรับคะแนนที่ท่านเลือกเกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่',
      thisAlready: 'คุณได้ทำรายการนี้ไปแล้ว',
      thisAlreadyActivity: 'คุณเข้าร่วมกิจกรรมแล้ว',
      alreadyRegis: 'คุณได้สมัครสมาชิกแล้ว',
      useForRedeem: 'ในการแลกรับของรางวัล',
      PleaseSelect: 'กรุณาเลือก',
      all: 'ทั้งหมด',
      EnterData: 'กรอกข้อมูล',
      questions: 'ข้อ',
      forGet: 'รับไปเลย',
      answer: 'ร่วมสนุกตอบคำถาม',
      noQuestions: 'คำถามที่',
      oneAnswer: 'เลือก 1 คำตอบ',
      moreChoice: 'เลือกได้หลายคำตอบ',
      get: 'รับ',
      addPoint: 'คุณได้รับคะแนนเพิ่ม',
      getTopicPoint: 'ได้รับคะแนน',
      useTopicPoint: 'ใช้คะแนน/ยกเลิกคะแนน',
      seePoint: 'ดูคะแนนสะสม และ ของรางวัล',
      getFreePoint: 'รับCoinsฟรี',
      confirmGetReward: 'ยืนยันรับของรางวัล',
      upLevel: 'และได้อัพเกรดเป็นสมาชิก',
      seeMorePre: 'ดูสิทธิประโยชน์ที่ได้รับเพื่มเติม',
      fill: 'กรุณากรอกข้อมูล',
      fillNum: 'กรุณากรอกตัวเลข 0 ถึง 9',
      chooseAddress: 'เลือกที่อยู่จัดส่ง',
      addAddress: 'เพิ่มที่อยู่',
      selectAddress: 'เลือกที่อยู่นี้',
      plsFillName: 'กรุณากรอกชื่อ-นามสกุล',
      plsFillTel: 'กรุณากรอกเบอร์โทรศัพท์',
      plsAddressNum: 'กรุณากรอกบ้านเลขที่',
      detailAdrres: 'รายละเอียดที่อยู่',
      plsPoscal: 'กรุณากรอกรหัสไปรษณีย์',
      plsPoscalNotic: 'รหัสไปรษณีย์ต้องมีตัวเลข 5 ตัว',
      notFoundPoscal: 'ไม่เจอรหัสรหัสไปรษณีย์',
      poscal: 'รหัสไปรษณีย์',
      plsFillProvince: 'กรุณากรอกจังหวัด',
      subDistrict: 'ตำบล',
      district: 'อำเภอ',
      province: 'จังหวัด',
      plsFillDistrict: 'กรุณากรอกอำเภอ',
      plsFillSubDistrict: 'กรุณากรอกตำบล',
      sendRewardAddress: 'จัดส่งตามที่อยู่นี้ด้านล่าง',
      deliveryAdd: 'ที่อยู่ที่จัดส่ง',
      addressNo: 'ที่อยู่',
      seccessAddress: 'เพิ่มที่อยู่เรียบร้อย',
      inviteFri: 'ชวนเพื่อเข้าใช้บริการ รับ',
      regis: 'เปิดบัตรสมาชิก',
      fromFeedBack: 'จากแบบสอบถาม',
      regisGetPoint: 'เปิดบัตรสมาชิกรับ',
      loginAccount: 'เข้าสู่ระบบสมาชิก',
      login: 'เข้าสู่ระบบ',
      memberIdFill: 'กรุณากรอกรหัสสมาชิกหลังบัตร',
      expireReward: 'หมดอายุ',
      fillTel: 'กรอกเบอร์โทรศัพท์',
      confirmPin: 'กรุณากรอก pin',
      notMemberAndRegis: 'คุณยังไม่เป็นสมาชิก ต้องการสมัครสมาชิก ใช่หรือไม่ ?',
      registorYet: 'ต้องการ สมัครสมาชิก ใช่หรือไม่?',
      registorYet2: 'ต้องการ ลงทะเบียน ใช่หรือไม่?',
      incorectPin: 'pin ไม่ถูกต้อง',
      thisTelAlready: 'เบอร์โทรศัพท์นี้ถูกใช้สมัครไปแล้ว',
      barcode: 'รหัสมาชิก barcode',
      contract: 'เลขสัญญา',
      already: 'ถูกใช้งานแล้ว',
      notFoundThisMemberId: 'กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบข้อมูลของท่าน \n*โปรดตรวจสอบเลขที่สัญญา ตัวอักษร และเบอร์โทรศัพท์ให้ตรงตามที่ระบุในสัญญา',
      incorrectOtp: 'otp ไม่ถูกต้อง',
      pinNotMatch: 'รหัส pin ไม่ตรงกัน',
      changePicture: 'เปลี่ยนรูปโปรไฟล์',
      confirmYourPin: 'ยืนยัน PIN ของคุณ',
      createPin: 'สร้าง PIN ของคุณ',
      reasonCreate: 'เพื่อความปลอดภัยในการเข้าสู่ระบบผ่านเบอร์โทรศัพท์',
      confirmOtp: 'กรุณายืนยัน OTP',
      waiting: 'กรุณารอสักครู่',
      pointMore: 'คะแนน',
      otpAccept: 'ยืนยัน OTP',
      otpSentTo: 'OTP ได้ส่งไปยังเบอร์',
      enterOtp: 'กรอก OTP',
      forgotPin: 'ลืมรหัสผ่าน ?',
      linkAccountLine: 'เบอร์นี้ได้ผูก line account แล้ว',
      resetOtpPin: 'ยืนยัน OTP เพื่อตั้งค่า pin ใหม่',
      resetPin: 'ตั้งค่า pin ของคุณใหม่',
      resetPinMessage: 'ตั้งค่า pin ของคุณเป็นตัวเลข 6 ตัว',
      newPin: 'pin ใหม่',
      confirmNewPin: 'ยืนยัน pin ใหม่',
      changePin: 'เปลี่ยน pin',
      changePinSucces: 'เปลี่ยน pin เรียบร้อย',
      newPinIs: 'pin ใหม่ของคุณคือ ',
      telephone: 'เบอร์โทรศัพท์',
      loginToMember: 'เข้าสู่ระบบสมาชิก',
      forCheckPoint: 'เพื่อเช็คคะแนนสะสม ยอดใช้จ่าย',
      close: 'ปิด',
      telIsLinkedLineId: 'เบอร์โทรศัพท์นี้ได้ผูกกับไลน์แล้ว',
      plsFillId: 'กรุณาหรอกรหัสของท่าน',
      notHaveExpire: 'ไม่มีวันหมดอายุ',
      showDiscountToStaff: 'โชว์ส่วนลดนี้ให้พนักงาน',
      copyLink: 'คัดลอกลิงก์',
      redeemingReward: 'กำลังแลกของรางวัล',
      servicesAvailable: 'บริการที่ใช้ได้',
      plsSelectService: 'กรุณาเลือกบริการที่ต้องการใช้',
      usePackage: 'ใช้แพ็กเกจ',
      packageDetails: 'รายละเอียดการใช้แพ็กเกจ',
      packageName: 'แพ็กเกจ',
      package: 'แพ็กเกจ',
      service: 'บริการ',
      plsSelectbranch: 'กรุณาเลือกสาขา',
      confirmApp: 'ยืนยันและนัดหมาย',
      backToHomePage: 'กลับหน้าหลัก',
      ExchangeToDiscount: 'แลกส่วนลด',
      Discount: 'ส่วนลด',
      Bath: 'บาท',
      remainPoint: 'คะแนนคงเหลือ',
      DiscountEarned: 'ส่วนลดที่ได้',
      PointsExchanged: 'คะแนนที่แลก',
      InvalidInput: 'กรอกข้อมูลไม่ถูกต้อง',
      InputPoint: 'กรุณาป้อนคะแนนที่ต้องการแลก',
      EnterPoints: 'คะแนนที่ต้องการแลก',
      MyPoint: 'คะแนนของฉัน',
      PointsUsed: 'คะแนนที่ใช้ไป',
      DiscountAlert: 'คุณต้องการแลกส่วนลดใช่หรือไม่ ?',
      ContactStaffMessage: 'ไม่สามารถแลกส่วนลดได้ โปรดติดต่อเจ้าหน้าที่',
      ScanQr: 'กรุณาแสดง Qr-code ให้พนักงานสแกน',
      RateExchange: 'อัตราการแลกเปลี่ยน',
      DetailPoint: 'คะแนนคือค่าที่คุณได้รับหรือสะสมจากการทำภารกิจบางอย่าง เช่น การซื้อสินค้า, การเข้าร่วมกิจกรรม โดยคะแนนนี้สามารถแลกเป็นสิทธิพิเศษ, ส่วนลด, สินค้า, บริการ, หรือประโยชน์อื่น ๆ ได้ตามเงื่อนไขที่กำหนด',
      error: 'ไม่สามารถทำรายการได้',
      TryAgain: 'กรุณาลองอีกครั้งในภายหลัง',
      total: 'จำนวน',
      times: 'ครั้ง',
      closeActivity: 'กิจกรรมถูกปิด',
      billingNo: 'เลขที่ใบเสร็จ',
      Inredeem: 'ในการแลกรับของรางวัล',
      model: 'โมเดลสินค้า',
      proType: 'ประเภทสินค้า',
      price: 'ราคา',
      noData: 'ไม่มีข้อมูล',
      timeOutGetReward: 'หมดเวลารับของรางวัล',
      plsGetRewardIn: 'กรุณาแลกรับของรางวัลภายใน',
      min: 'นาที',
      plsStafScan: 'กรุณาให้พนักงานสแกน qrcode',
      empId: 'รหัสตัวแทน',
      packageAlready: 'คุณได้รับการยืนยันซื้อแพ็กเกจแล้ว',
      checkRewardForpackage: 'สามารถตรวจสอบของรางวัลได้ที่รางวัลของฉัน',
      openCode: 'เปิดดูของรหัสของรางวัล',
      specailLMG: 'คะแนนกิจกรรมพิเศษ',
      youGet: 'คุณได้รับ',
      customerCode: 'เลขสัญญา',
      contractExpireDate: 'วันหมดอายุ',
      notmatchTel: 'ไม่ตรงกัน',
      andTel: ' และ เบอร์โทร',
      mustBeMatchConNo: '(ที่ระบุในสัญญา)'
    }
  },
  en: {
    message: {
      thisTelNotUsed: 'This phone number cannot be used',
      confirm: 'Confirm',
      yes: 'Yes',
      nameOffice: '(Company name)',
      contractExpireDate: 'Expire Date.',
      customerCode: 'Contract No.',
      openCode: 'Open Rewarcd Code',
      checkRewardForpackage: 'You can check your rewards in "My Rewards."',
      packageAlready: 'Your package purchase has been confirmed.',
      hello: '👋 welcome',
      welcomeToShop: 'Welcome to our shop',
      detailMember: 'Member information',
      currntPoint: 'Current Points',
      myReward: 'My Rewards',
      MyReward: 'My Rewards',
      privileges: 'Package',
      memberId: 'MemberId',
      level: 'Member level',
      nameSurname: 'Name',
      nameSurnameEazyCar: 'Name provided in the contract',
      nameSurnameStampCGS: 'ชื่อ-นามสกุล (ภาษาไทย)',
      tel: 'Telephone number',
      telCGS: 'Telephone number',
      birtDay: 'Birthday',
      before: 'Before',
      language: 'EN',
      yougetPoint: 'You got the points',
      youUsePoint: 'You redeem points',
      backToPromotion: 'Back to Promotion page',
      point: 'point',
      thb: 'Baht',
      pointMore: 'more points',
      NotiUsePoint: 'Notification for used points',
      NotiGetPoint: 'Notification for get points',
      mypoint: 'My Point',
      youRefund: 'Retrieve',
      promotion: 'Promotions',
      campaign: 'Campaign',
      allCampaign: 'All Campaign',
      validUntil: 'Valid until',
      reward: 'Rewards',
      viewAll: 'View All',
      succesRegis: 'Successfully registered',
      useForRedeem: 'redeeming reward',
      notHavepromotion: 'You can follow interesting promotions here',
      buyPackage: 'Buy package',
      freePackage: 'Get Free Package',
      home: 'Home',
      package: 'Package',
      account: 'Account',
      activity: 'Activity',
      contact: 'Contact',
      allPromotion: 'All Promotion',
      viewDetails: 'View details',
      ReceiveAtStore: 'Receive rewards at the store',
      presslink: 'Click the link above to claim your reward',
      delivery: 'Delivery',
      usePoint: 'Use Point',
      seeMore: 'More detail',
      allReward: 'All Reward',
      outStock: 'out of stock',
      inventories: 'Inventories',
      registorYet2: 'Do you want to register?',
      registorYet: 'Want to registor for membership?',
      visiter: 'visiter',
      redeemReward: 'Redeem Reward',
      showQrcodeReward: 'Please show this QR Code to the staff.',
      showBarcodeReward: 'Please show this Barcode to the staff.',
      rewardDetail: 'Reward Details',
      useBefor: 'use before',
      collectMore: 'collect',
      memberHightLevel: 'Your membership card level is at the highest level.',
      levelUp: 'for level up to',
      fromBuyAndService: 'from purchasing products',
      fromPackage: 'from purchasing package',
      fromFrigetFri: 'from avtivity friend get friend',
      fromWelcome: 'from avtivity Welcome point',
      fromBirth: 'from avtivity Birth day point',
      fromRefund: 'from canceling receipt',
      privilegeDetail: 'Privilege Detail',
      expirePoint: 'Expires in',
      expirePointTopic: 'Expire Point',
      view: 'view',
      allLevel: 'All Level',
      pointHistory: 'Point History',
      policy: 'Privacy Policy',
      rewardHistory: 'Rewards history',
      otpAccept: 'confirm otp',
      mounth: 'mounth',
      thisAlreadyActivity: 'already this activity',
      privilegeLevel: 'Privilege Level',
      youPoint: 'my point',
      expireReward: 'Expire Reward',
      useReward: 'use the reward',
      received: 'received',
      type: 'type',
      deliveryLocation: 'Delivery location',
      parcelNumber: 'parcel number',
      transportationService: 'Transportation service',
      linkcode: 'Code or reward link',
      waitDelivery: 'Waiting for delivery',
      waiting: 'Waiting for otp',
      alreadyShip: 'Already shipped',
      redeemDate: 'Redemm Date',
      myPackage: 'My Special package',
      allPackage: 'All package',
      availablePackages: 'Available',
      packageHistory: 'Package usage history',
      unusablePackage: 'Unavailable',
      dontUnusablePackage: 'You dont have an expired or used up package.',
      dontPackage: 'You dont have a package.',
      balance: 'balance',
      usePackeage: 'use packeage',
      outPackage: 'out of packeage',
      waitStore: 'Please wait for the store to process.',
      storeNotice: 'When the store confirms the money transfer slip, a notification will be sent to the customer via the store Line OA.',
      useAndappoint: 'Using the package and making an appointment.',
      detailPackage: 'Detail Package',
      productsServices: 'Products/Services',
      productsServicesLMG: 'Sales',
      expirePoint2: 'expire point',
      date: 'date',
      new: 'New',
      branch: 'branch',
      condition: 'Accept Terms and Conditions',
      condition2: 'I agree to receive new and other benefits through email, SMS, application, social media, phone, and direct  mail from',
      selectGender: 'Please select your gender',
      regisMember: 'Sign up',
      regisMemberConfirm: 'Confirm sign up',
      register: 'Sign up',
      registerRxTrader: 'Register to participate in the activity.',
      referralCode: 'Referral code.',
      joinActivity: 'Join the activity',
      privilegesRemaining: 'Privileges remaining',
      claimFree: 'claim for free',
      NoLimitPrivileges: 'No limit of Privileges',
      getPoint: 'get point',
      fullPrivilege: 'Full Privilege',
      friendFetFriend: 'friend get friend',
      getFriendHistory: 'get friend history',
      inviteUseservice: 'Invite friends to use our services',
      pointsEarned: 'Points earned',
      referralQuota: 'You have reached your referral quota',
      startActivity: 'Start activity',
      Invitemembership: 'Invite friends to open a membership card.',
      canInvite: 'You can invite friends.',
      InviteServiceReceive: 'Invite friends to use the service and receive',
      howtoGetFriend: 'how to get friend',
      shareLinkLine: 'Share the link within the Line application.',
      EarnInvitingFriends: 'Earn points for inviting friends',
      wayGetFriend: 'choose to invite friends in',
      towWay: '2 ways.',
      fill: 'fill data',
      Method1: 'Method 1',
      Method2: 'Method 2',
      NoLimit: 'No limit',
      countTime: 'time',
      shareCode: 'Share the code below with your friends',
      copy: 'copy',
      allPointGet: 'Total points earned',
      address: 'Address',
      allBranch: 'All branchs',
      map: 'map',
      credit: 'Credit',
      historyCredits: 'Credits Transaction',
      myCredis: 'My credits',
      currentCredits: 'current credits',
      totalCredits: 'total credit',
      status: 'status',
      increase: 'increase',
      decrease: 'decrease',
      rewardCode: 'reward code',
      completeReward: 'Complete',
      expireDate: 'expire date',
      collectedReward: 'This reward must be collected at our office.',
      collectedStaffReward: 'This reward must be collected from the staff at the event only.',
      Viewrewards: 'View all of your rewards.',
      ConfirmReward: 'Confirm redeem the reward',
      cancle: 'Cancel',
      use: 'use',
      useLinkOrCode: 'You can use the code or link above to instantly receive special privileges',
      pointInsufficient: 'Your points are insufficient.',
      howToGetPoint: 'Would you like to view the terms and conditions for earning points ?',
      memberInsufficient: 'Your membership card level is insufficient :(',
      redeemLevel: 'You can redeem this offer only for members with',
      orHight: 'level or higher',
      uploadPayment: 'Upload your payment slip.',
      save: 'save',
      accountBank: 'Bank Account',
      feedBack: 'Questionnaire',
      fromFeedBack: 'From questionnaire',
      amount: 'Amount',
      afterUpload: 'After successfully transferring the money, please upload the payment slip',
      selectPayment: 'Select a payment method',
      paymentTotal: 'Payment total',
      sorry: 'I apologize!',
      alreadyUsePackage: 'This package has already been used',
      wantToupLoadPayment: 'Do you want to confirm the uploaded money transfer slip?',
      complete: 'complete',
      fail: 'fail',
      pointBeenReceived: 'These points have already been received',
      ok: 'ok',
      message: 'There was an error in redeeming the points you selected. Please contact our staff for assistance',
      thisAlready: 'You have already performed this transaction',
      alreadyRegis: 'You have already registered',
      PleaseSelect: 'Please select',
      all: 'All',
      EnterData: 'Enter information',
      questions: 'questions',
      forGet: 'for get',
      answer: 'Participate and answer',
      noQuestions: 'questions',
      oneAnswer: 'Choose 1 answer',
      getTopicPoint: 'Receive point',
      useTopicPoint: 'Redeem point/Cancel Point',
      moreChoice: 'can choose multiple answers',
      get: 'get',
      addPoint: 'You have earned additional points',
      seePoint: 'View accumulated points and rewards.',
      getFreePoint: 'get point free',
      confirmGetReward: 'Confirm receiving the reward',
      upLevel: 'and have upgraded to a member',
      seeMorePre: 'View more benefits received',
      fillNum: 'Please enter a number from 0 to 9',
      chooseAddress: 'Choose Address',
      addAddress: 'Add adress',
      selectAddress: 'select this address',
      plsFillName: 'Please enter your full name',
      plsFillTel: 'Please enter your tel',
      plsAddressNum: 'Please enter your address detail',
      detailAdrres: 'detail address',
      plsPoscal: 'Please enter your poscal code',
      plsPoscalNotic: 'poscal code must have 5 character',
      notFoundPoscal: 'not found this poscal code',
      poscal: 'poscal',
      plsFillProvince: 'Please enter your Province',
      subDistrict: 'sub-district',
      district: 'district',
      province: 'province',
      plsFillDistrict: 'Please enter your district',
      plsFillSubDistrict: 'Please enter your sub-district',
      sendRewardAddress: 'Deliver to the address below',
      deliveryAdd: 'Delivery address',
      addressNo: 'address no',
      seccessAddress: 'Address added successfully.',
      inviteFri: 'invite friend use service get',
      regis: 'registor member',
      regisGetPoint: 'registor member and get',
      loginAccount: 'Log in to your account',
      login: 'Login',
      memberIdFill: 'Membership card number',
      fillTel: 'Enter telephone number (Thai phone numbers only)',
      back: 'back',
      confirmPin: 'Please confrim your pin',
      notMemberAndRegis: 'You are not a member yet. Do you want to sign up for membership ?',
      incorectPin: 'incorrect pin',
      thisTelAlready: 'this tel is member already',
      barcode: 'member id',
      already: 'has been already',
      notFoundThisMemberId: 'Please contact our staff to verify your information. \n*Kindly ensure that your contract number, letters, and phone number match those stated in the contract',
      incorrectOtp: 'otp incorrect',
      pinNotMatch: 'pin number not match',
      changePicture: 'change profile picture',
      confirmYourPin: 'Confirm Your Pin',
      createPin: 'Create Your Pin',
      reasonCreate: 'For security purposes, please log in using your phone number',
      confirmOtp: 'Please confirm OTP',
      otpSentTo: 'otp has sended to',
      enterOtp: 'enter otp',
      forgotPin: 'forgot pin ?',
      linkAccountLine: 'This number has been linked to a LINE account.',
      resetOtpPin: 'confirm otp to reset pin',
      resetPin: 'Reset your pin',
      resetPinMessage: 'Reset your pin six-digit number',
      newPin: 'new pin',
      confirmNewPin: 'confirm new pin',
      changePin: 'change pin',
      changePinSucces: 'change pin success',
      newPinIs: 'your new pin is ',
      telephone: 'telephone',
      loginToMember: 'Member Login',
      forCheckPoint: 'check collect point and Total Spending',
      close: 'close',
      telIsLinkedLineId: 'this tel number has linked',
      plsFillId: 'please fill your member ID',
      notHaveExpire: 'not expire',
      noData: 'No Data',
      showDiscountToStaff: 'show this Discount to staff',
      copyLink: 'copy link',
      redeemingReward: 'redeeming reward in progress',
      servicesAvailable: 'Services are available',
      plsSelectService: 'Please select a service',
      usePackage: 'Use package',
      packageDetails: 'Package usage details',
      packageName: 'Package name',
      service: 'Service name',
      plsSelectbranch: 'Please select a branch',
      confirmApp: 'Confirm and appointment',
      backToHomePage: 'Back To HomePage',
      ExchangeToDiscount: 'Redeem discount',
      Discount: 'Discount',
      Bath: 'Bath',
      remainPoint: 'Remain points',
      DiscountEarned: 'Discount',
      PointsExchanged: 'Exchanged',
      InvalidInput: 'Incorrect Data Entry',
      InputPoint: 'Please enter the points you want to redeem.',
      EnterPoints: 'Enter points',
      MyPoint: 'My Points',
      PointsUsed: 'Points Used',
      DiscountAlert: 'Do you want to redeem this discount ?',
      ContactStaffMessage: 'Unavailable, Please contact our staff.',
      ScanQr: 'Please show the Qr-code to our staff.',
      allLevels: 'All levels',
      RateExchange: 'Exchange rate',
      DetailPoint: 'Points are rewards earned from tasks like purchases or activities. They can be traded for perks, discounts, products, services, or other benefits based on set conditions.',
      error: 'Unable to process transaction.',
      TryAgain: 'Please try again later',
      total: 'Total',
      times: 'time(s)',
      closeActivity: 'this activity is close',
      billingNo: 'Billing Number',
      Inredeem: 'In redeeming prizes',
      model: 'Model',
      proType: 'Product type',
      price: 'Price',
      fromActivity: 'from activity',
      timeOutGetReward: 'The time to receive the reward has expired.',
      plsGetRewardIn: 'Please redeem the reward within',
      min: 'minute',
      plsStafScan: 'Please have the staff scan the QRcode.',
      empId: 'Agent ID',
      specailLMG: 'Special activity points',
      youGet: 'you received',
      notmatchTel: 'not match',
      andTel: ' and PhoneNumber',
      contract: 'Contract No.',
      mustBeMatchConNo: '(As stated in the contract)'
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'th', // set locale
  messages // set locale messages
})
Vue.mixin(globalMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js